var render = function () {
  var _vm$lecture, _vm$lecture2, _vm$lecture2$meta, _vm$lecture2$meta$wat, _vm$lecture2$meta$wat2, _vm$lecture3, _vm$lecture3$files, _vm$lecture4, _vm$lecture4$links, _vm$lecture5, _vm$lecture6;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    ref: "info-card",
    attrs: {
      "outlined": ""
    }
  }, [_vm._t("default"), _c('v-divider'), _c('v-card-text', [_c('v-row', {
    staticClass: "mx-n4 mt-n4 mb-0",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "pa-4 font-size-18 font-weight-bold text-truncate"
  }, [_vm._v(" " + _vm._s((_vm$lecture = _vm.lecture) === null || _vm$lecture === void 0 ? void 0 : _vm$lecture.subject) + " ")]), _c('v-col', {
    staticClass: "pa-4",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-chip', {
    attrs: {
      "small": "",
      "outlined": ""
    }
  }, [_vm._v(_vm._s((_vm$lecture2 = _vm.lecture) === null || _vm$lecture2 === void 0 ? void 0 : (_vm$lecture2$meta = _vm$lecture2.meta) === null || _vm$lecture2$meta === void 0 ? void 0 : (_vm$lecture2$meta$wat = _vm$lecture2$meta.watcherCount) === null || _vm$lecture2$meta$wat === void 0 ? void 0 : (_vm$lecture2$meta$wat2 = _vm$lecture2$meta$wat.format) === null || _vm$lecture2$meta$wat2 === void 0 ? void 0 : _vm$lecture2$meta$wat2.call(_vm$lecture2$meta$wat)) + "명 참여")])], 1)], 1), _vm.isUserCompany ? _c('v-row', {
    staticClass: "mx-n4 mt-0 mb-n4",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "px-4 pt-0 pb-4 font-size-14",
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('info-link')], 1), _c('v-col', {
    staticClass: "px-4 pt-0 pb-4 font-size-14",
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('info-code')], 1), 0 < ((_vm$lecture3 = _vm.lecture) === null || _vm$lecture3 === void 0 ? void 0 : (_vm$lecture3$files = _vm$lecture3.files) === null || _vm$lecture3$files === void 0 ? void 0 : _vm$lecture3$files.length) || 0 < ((_vm$lecture4 = _vm.lecture) === null || _vm$lecture4 === void 0 ? void 0 : (_vm$lecture4$links = _vm$lecture4.links) === null || _vm$lecture4$links === void 0 ? void 0 : _vm$lecture4$links.length) ? _c('v-col', {
    staticClass: "pa-4 font-size-14",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-chip-group', {
    staticClass: "ma-n4",
    attrs: {
      "column": ""
    }
  }, [_vm._l((_vm$lecture5 = _vm.lecture) === null || _vm$lecture5 === void 0 ? void 0 : _vm$lecture5.files, function (file) {
    return [_c('v-chip', {
      key: file._id,
      staticClass: "ma-4",
      attrs: {
        "href": file.url,
        "outlined": "",
        "large": "",
        "label": "",
        "width": "32",
        "min-width": "32",
        "height": "32",
        "download": ""
      }
    }, [_vm._v(" " + _vm._s(file.fileName) + " "), _c('v-icon', {
      staticClass: "ml-4",
      attrs: {
        "small": ""
      }
    }, [_vm._v(" mdi-download ")])], 1)];
  }), _vm._l((_vm$lecture6 = _vm.lecture) === null || _vm$lecture6 === void 0 ? void 0 : _vm$lecture6.links, function (link) {
    return [_c('v-chip', {
      key: link._id,
      staticClass: "ma-4",
      attrs: {
        "href": link.href,
        "download": link.isDownload,
        "target": link.isDownload ? undefined : '_blank',
        "outlined": "",
        "large": "",
        "label": "",
        "width": "32",
        "min-width": "32",
        "height": "32"
      }
    }, [_vm._v(" " + _vm._s(link.name) + " "), link.isDownload ? [_c('v-icon', {
      staticClass: "ml-4",
      attrs: {
        "small": ""
      }
    }, [_vm._v(" mdi-download ")])] : [_c('v-icon', {
      staticClass: "ml-4",
      attrs: {
        "small": ""
      }
    }, [_vm._v(" mdi-open-in-new ")])]], 2)];
  })], 2)], 1) : _vm._e()], 1) : _vm._e()], 1)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }